import { eras } from "@/mocks/heigua";
import SectionHeading from "./SectionHeading";

export default function Timeline() {
  return (
    <section id="timeline" className="border-y border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-8 lg:flex-row lg:gap-14">
          <div className="lg:sticky lg:top-24 lg:self-start lg:w-72 xl:w-80">
            <SectionHeading
              index="贰"
              eyebrow="Chronology"
              title="年份时间线"
              subtitle="从围观到档案化，回看这几年大众舆论与内容方式的演进脉络。想追一件事怎么发展起来，顺着这条线往下看。"
            />
            <p className="mt-5 hidden text-sm leading-relaxed text-foreground-500 lg:block">
              每个阶段对应不同的大众参与方式与传播特征，把它们串起来，就是这几年内容风向的地图层。
            </p>
          </div>

          <ol className="relative flex-1 space-y-6 border-l border-background-300 pl-0 md:space-y-7">
            {eras.map((era) => (
              <li key={era.label} className="relative md:pl-14">
                {/* 标记点 */}
                <span className="absolute left-0 top-2 hidden h-px w-8 bg-accent-500/70 md:block" />
                <span className="absolute left-[-5px] top-1.5 hidden h-2.5 w-2.5 rounded-full border-2 border-accent-500 bg-background-50 md:block" />

                <article className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
                      <i className="ri-sparkling-line" />
                      {era.label}
                    </span>
                    <span className="font-heading text-sm font-bold text-primary-700">{era.years}</span>
                    <span className="text-xs text-foreground-400">{era.marker}</span>
                  </div>
                  <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950 md:text-xl">
                    {era.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{era.summary}</p>
                </article>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}